import React from 'react';

export default function HomeAboutIntro() {
  return (
    <section className="intro" id="company" aria-labelledby="company-title">
      <div>
        <p className="eyebrow dark">About DALMAF</p>
        <h2 id="company-title" className="dh-title-2">
          Preparing your business with sharper governance, cleaner records, and stronger protection.
        </h2>
      </div>
      <div className="intro-panel">
        <p className="dh-text">
          DALMAF brings professionalism, integrity, sector expertise, and a client-focused mindset
          into every engagement. We are a premium business advisory partner for compliance-heavy,
          documentation-heavy, and growth-ready companies.
        </p>
        <ul>
          <li>Expert legal consulting and comprehensive audit services.</li>
          <li>Professional legal research and in-depth audit analysis.</li>
          <li>Tailored compliance support for each organisation's needs.</li>
        </ul>
      </div>
    </section>
  );
}
